export default {
  grievances: "/grievances",
  updateGrievance: "/grievances/update",
  deleteGrievance: "/grievances/delete",
  deleteGrievanceAttachment: "/grievances/delete/attachment",
};
